import { jsx as _jsx } from "react/jsx-runtime";
import React, { useContext } from 'react';
import { getKeyHandler } from '../structure/FlowForm';
import './A.css';
import { goTo, RouterContext } from '../router';
const A = ({ children, href, target, rel, focusId, onClick, onFocus, onBlur, focussable = 'flow', className = '', keyOverride, keyHandler, onKeyDown, internal = false }) => {
    const router = internal == null ? href.startsWith('/') : internal;
    const routerCtx = router ? useContext(RouterContext) : null;
    const [clicked, setClicked] = React.useState(false);
    const navigate = () => {
        setClicked(true);
        setTimeout(() => setClicked(false), 200);
        onClick === null || onClick === void 0 ? void 0 : onClick();
        if (routerCtx)
            goTo(routerCtx, href);
        else
            setTimeout(() => window.open(href, target || '_self'), 0);
    };
    const handleKeyDown = getKeyHandler({
        enterBehaviour: 'action',
        spaceBehaviour: 'action',
        sidewaysBehaviour: 'both',
        onAction: () => navigate(),
        overrideHandlers: keyOverride,
        defaultHandler: keyHandler,
    });
    return (_jsx("a", { id: focusId, href: href, target: target, rel: rel, className: `linkA ${className} ${focussable == 'flow' ? 'flowFocussable' : (focussable == 'sideway' ? 'flowFocussable sidewayFocus' : '')} ${clicked ? 'clicked' : 'unclicked'}`, tabIndex: 0, onClick: (ev) => {
            ev.preventDefault();
            navigate();
        }, onFocus: onFocus, onBlur: () => onBlur === null || onBlur === void 0 ? void 0 : onBlur(), onKeyDown: onKeyDown || handleKeyDown, children: children }));
};
export default A;
